import { render, staticRenderFns } from "./individual_detial.vue?vue&type=template&id=380fd7aa&scoped=true"
import script from "./individual_detial.vue?vue&type=script&lang=js"
export * from "./individual_detial.vue?vue&type=script&lang=js"
import style0 from "./individual_detial.vue?vue&type=style&index=0&id=380fd7aa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380fd7aa",
  null
  
)

export default component.exports